import axios from 'axios';
import Cookie from 'cookies-js';
import jwt from 'jsonwebtoken';
// import toastr from 'toastr';
import config from '../../config/index';
import routes from '../../constants/routes';
import { GET_USER_MUTUAL_FUND } from '../types';

const userMutualFund = mutualFund => ({
  type: GET_USER_MUTUAL_FUND,
  mutualFund
});

const getUserMutualFund = () => (dispatch) => {
  const token = Cookie.get('jwtToken');
  const decodeToken = jwt.decode(token);
  const { customerId } = decodeToken;
  return axios.get(`${config.apiUrl}${routes.GETMUTUALFUND}/${customerId}`,
    {
      headers: { Authorization: `Bearer ${token}` }
    }).then((response) => {
    const {
      isSuccessful,
      mutualFunds,
      // responseMessage
    } = response.data;
    if (isSuccessful) {
      dispatch(userMutualFund(mutualFunds));
    }
  }).catch((error) => {
    throw error;
  });
};

export default getUserMutualFund;
